<template>
    <v-dialog v-model="dialog" scrollable max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" class="text-lowercase mr-4" dark small v-on="on">add insight</v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6 text-pre-wrap">
                New insight by <span class="secondary--text">{{ set.item }}</span> set
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-row>
                            <!--segment-->
                            <v-col cols="12" sm="6" md="6">
                                <v-select dense return-object v-model="segment" :items="segments" 
                                    item-text="segment.name"
                                    item-value="segment.segment"
                                    item-color="secondary" label="segment" @change="onceMore()"
                                    :rules="[rules.required]">
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="4" sm="6">
                                <v-text-field dense 
                                    color="secondary" label="weight" 
                                    v-model.number="weight"
                                    name="weight" 
                                    type="text" 
                                    :rules="[rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <!--text-->
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea dense counter rows="1" outlined auto-grow v-model="text" 
                                    color="secondary" label="text" 
                                    @change="onceMore()" :rules="[rules.required]">
                                </v-textarea>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error--text">{{ error }}</v-row>
                <v-row justify="center" class="text-pre-wrap subtitle-2">
                    {{ message }}
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" text class="text-capitalize" :disabled="!valid || Boolean(error)"
                    @click="addInsight">Save
                </v-btn>

                <v-btn color="secondary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'AddInsight',
    props: ['set', 'round'],
    data() {
        return {
            dialog: false,
            valid: false,
            error: '',
            message: '',
            rules: {
                required: v => !!v || 'this field is required',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number',
            },
            //props
            text: '',
            weight: 0,
            segment: {},
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        segments() {
            return this.$store.getters.market_segments;
        },
    },
    methods: {
        onceMore() {
            this.error = ''
            this.message = '';
        },
        async addInsight() {

            if (this.$refs.form.validate()) {

                const insight = {
                    gameId: this.set.value,
                    segmentId: this.segment.segmentId,
                    text: this.text,
                    segment: this.segment.segment,
                    weight: this.weight
                }
                /*console.log(insight);*/
               try {
                    //add insight
                    await this.$store.dispatch('addInsight', insight)
                    this.closeDialog()
                }
                catch (error) {
                    this.error = `${error.message}`;
                    this.message = '';
                    this.$store.dispatch('setError', error.message)//throw error
                }
            }
        },
        closeDialog() {
            //reset
            this.dialog = false;
            this.error = '';
            this.message = '';
            this.$refs.form.reset();
        }
    },
    async mounted() {
        if (this.segments.length < 1 && this.set?.item) {
            const gameId = Number(this.set.value);
            const round = Number(this.round);
                    
            try {
                await this.$store.dispatch('fetchMarketSegments', {gameId, round});
            }
            catch (err) {
                console.log(err)
            }
        }
    }
}
</script>